export const maxAllowedItemsInOrder = 999;

export const FETCH_ABORTED = 'aborted';
export const GLOBAL_CATALOG_ITEMS_PAGE_SIZE = 20;
export const GLOBAL_CATALOG_MAX_PAGES = 10;
